import { useCallback } from "react";
import { queriesNotifications } from "@query";
import { useSession } from "@hooks/useSession";

type UseMutationConfig = Parameters<
  typeof queriesNotifications.viewNotification.useMutation
>[0];

export const useMutationViewNotification = (config?: UseMutationConfig) => {
  const { personId } = useSession();
  const [viewNotification, meta] =
    queriesNotifications.viewNotification.useMutation(config);

  const view = useCallback(
    (notificationId: string) => viewNotification({ personId, notificationId }),
    [viewNotification, personId]
  );

  return [view, meta] as const;
};
